import GameState, { getXYindex, GameStateObj } from "../state/gameState";
import Phaser from "phaser";
import { EntityKind, Crate } from "../state/entityKinds";
import { Dir } from "./Player";
import BaseEntity from "./BaseEntity";
import { RemovedBecause } from "../state/rules/overlap";
import { GAME_VARIABLES, layerDepthDiff } from "../constants";
import { SoundPlayer } from "../sounds/SoundPlayer";

const BOARD_SIZE = 8;

export default class CrateGameObj extends BaseEntity {
  private sprite: Phaser.GameObjects.Sprite;
  constructor(gameState: GameState, scene: Phaser.Scene, obj: Crate) {
    super(gameState, scene);

    const { x: start_x, y: start_y } = obj;

    this.sprite = scene.add.sprite(
      start_x * BOARD_SIZE,
      start_y * BOARD_SIZE,
      "atlas",
      "Crate/Crate_1"
    );

    this.sprite.setDepth(start_y + layerDepthDiff.BOXES);

    const entity: Crate = {
      kind: EntityKind.Crate,
      id: this.id,
      x: start_x,
      y: start_y,
      reflects: obj.reflects || "",
      explodes: obj.explodes || false,
      breaks: obj.breaks === undefined ? true : obj.breaks,
      entity: () => this,
    };

    if (obj.reflects === "/") {
      this.sprite.setFrame("Crate/Mirror_diagonal1");
    } else if (obj.reflects === "\\") {
      this.sprite.setFrame("Crate/Mirror_diagonal2");
    }

    gameState.silentMutateGameState((state) => {
      this.idx = getXYindex(start_x, start_y);
      state.board[this.idx].push(entity);
    });
  }

  reflectSFX() {
    SoundPlayer.mirrorBounceSFX(this.scene);
  }

  afterMove() {
    if (this.entityImmutable) {
      this.sprite.setDepth(this.entityImmutable.y + layerDepthDiff.BOXES);
    } else if (this.sprite) {
      this.sprite.setDepth(
        Math.floor(this.sprite.y / 8) - 1 + layerDepthDiff.BOXES
      );
    } else {
      console.log("there is no more entity :<");
    }
  }

  _removeFromBoard(reason: RemovedBecause) {
    if (
      reason === RemovedBecause.ImpactSolid ||
      reason === RemovedBecause.BlownUp ||
      reason === RemovedBecause.Shot
    ) {
      SoundPlayer.crateBreakSFX(this.scene);
    }
    super._removeFromBoard(reason);
  }

  move(dir: Dir, isDelayed = false) {
    this.moveState(dir);
    SoundPlayer.cratePushSFX(this.scene);
    this._moveTween(dir, {
      targets: this.sprite,
      delay: isDelayed ? GAME_VARIABLES.MOVE_TIME_MS / 2 : 0,
      duration: GAME_VARIABLES.MOVE_TIME_MS / 2,
    });
  }

  undo(c: Crate) {
    this.scene.tweens.killTweensOf(this.sprite);
    this.sprite.alpha = 1;
    this.sprite.x = c.x * 8;
    this.sprite.y = c.y * 8;
    this.idx = getXYindex(c.x, c.y);
    this.sprite.setVisible(true);
    this.sprite.setActive(true);
    this.sprite.setDepth(c.y + layerDepthDiff.BOXES);
  }
}
